// extracted by mini-css-extract-plugin
module.exports = {"socialButton":"SocialButton-module_socialButton_5ee17"};